import { View, StyleSheet, TouchableOpacity } from "react-native";
import React from "react";
import Text from "@components/CustomText";
import color from "@constants/color";
import ChevronRight from "@assets/svg/ChevronRight";
import Recon from "@assets/svg/DbManagement/Recon";
import ManageDB from "@assets/svg/DbManagement/ManageDB";
import LocationCity from "@assets/svg/LocationCity";
import Routing from "@assets/svg/DbManagement/Routing";
import OutForDelivery from "@assets/svg/DbManagement/OutForDelivery";
import { useNavigation } from "@react-navigation/native";

const ListTile = ({ item }) => {
  const navigation = useNavigation();
  const getIcon = (type) => {
    switch (type) {
      case "ROUTING":
        return <Routing />;
      case "OUT_FOR_DELIVERY":
        return <OutForDelivery />;
      case "RECON":
        return <Recon />;
      case "MANAGE_DELIVERY_BOY":
        return <ManageDB />;
      case "LIVE_DB_MAP":
        return <LocationCity width={40} height={40} />;
      default:
        return null;
    }
  };
  const subTitle = ({ subtitle, value }) => {
    return (
      <View style={styles.captionValueContainer}>
        <Text variant="caption_2" style={styles.subtitle}>
          {subtitle}
        </Text>
        <Text variant="caption_2" style={styles.value}>
          {value || "--"}
        </Text>
      </View>
    );
  };

  return item?.show_card === false ? null : (
    <TouchableOpacity
      testID="Dbm-list-tile"
      style={styles.container}
      activeOpacity={0.8}
      disabled={item?.nav_to === ""}
      onPress={() => {
        if (item?.nav_to) {
          navigation.navigate(item?.nav_to, {
            nav_params: item?.nav_params_data,
          });
        }
      }}
    >
      <View style={styles.headerContent}>
        <View style={styles.icon}>{getIcon(item?.type)}</View>
        <View>
          <Text variant="title_16" style={{ color: color.mediumBlack }}>
            {item?.title}
          </Text>
          {item?.subtitle_1
            ? subTitle({
                subtitle: item?.subtitle_1,
                value: item?.subtitle_1_value,
              })
            : null}
          {item?.subtitle_2
            ? subTitle({
                subtitle: item?.subtitle_2,
                value: item?.subtitle_2_value?.toString(),
              })
            : null}
        </View>
      </View>
      <View style={styles.chevronContainer}>
        <ChevronRight
          pathFill={color.lightMediumBlack}
          style={styles.chevronIcon}
        />
      </View>
    </TouchableOpacity>
  );
};

export default ListTile;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 12,
    borderRadius: 16,
    borderColor: color.lighterBlack,
    borderWidth: 0.5,
    margin: 16,
    marginVertical: 8,
    backgroundColor: color.white,
    minHeight: 64,
    elevation: 1,
    alignItems: "center",
  },
  icon: {
    marginRight: 12,
    justifyContent: "center",
    alignItems: "center",
  },
  chevronContainer: {
    backgroundColor: color.lightGrayWhite,
    padding: 3,
    borderRadius: 4,
  },
  chevronIcon: {
    height: 16,
    width: 16,
  },
  captionValueContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  subtitle: {
    color: color.black06,
    marginRight: 2,
    lineHeight: 18,
  },
  value: {
    color: color.mediumBlack,
    fontWeight: "bold",
  },
  headerContent: {
    flexDirection: "row",
  },
});
